// @flow
import React from 'react';
import {
    Divider,
    Input,
    Button,
    Popconfirm,
    Form,
    Layout,
    Spin,
    Tag,
    Table,
    Tooltip,
    Typography,
    Skeleton
} from 'antd';
import { FileTextOutlined, PushpinOutlined } from '@ant-design/icons';

import { PageMode, setPageMode } from './GlobalParams';
import DataTable from './DataTable';

import InfiniteScroll from 'react-infinite-scroller';

const { Header, Content } = Layout;

import type { T_Highlight } from '../../src/types';

import Toolbar from './Toolbar';

const { Title, Paragraph, Text } = Typography;

const updateHash = (highlight) => {
    location.hash = `highlight-${highlight.id}`;
};

export default class Sidebar extends React.Component {
    state = {
        tipMsg: ''
    };

    onSelectedRowKeysChange = (selectedRowKeys, selectedRows) => {
        let item = selectedRows[0];
        if (this.props.selectedHighlightId != item.key) {
            this.props.setSelectedHighlightId(item.key);
            updateHash(item);
        }
    };

    render() {
        return (
            <div>
                <Spin
                    size="large"
                    spinning={this.props.isGetDataLoading}
                    paragraph={{ rows: 5 }}
                    tip={this.state.tipMsg}
                >
                    <Header
                        style={{
                            height: '10vh'
                        }}
                    >
                        <Toolbar
                            highlights={this.props.highlights}
                            importHighlights={this.props.importHighlights}
                            setSelectedHighlightId={
                                this.props.setSelectedHighlightId
                            }
                            fileId={this.props.fileId}
                            fileRef={this.props.fileRef}
                            reloadData={this.props.reloadData}
                            afterSave={this.props.afterSave}
                            setIsGetDataLoading={(val, msg) => {
                                this.setState({ tipMsg: msg });
                                this.props.setIsGetDataLoading(val);
                            }}
                        />
                    </Header>

                    <Content
                        style={{
                            overflow: 'auto',
                            height: '90vh'
                        }}
                    >
                        <DataTable
                            selectedHighlightId={this.props.selectedHighlightId}
                            setSelectedHighlightId={
                                this.props.setSelectedHighlightId
                            }
                            dataSource={this.props.highlights}
                            isGetDataLoading={this.props.isGetDataLoading}
                        />
                    </Content>
                </Spin>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./demo/src/Sidebar.js